export default `float de(vec3 p){
    vec3 Q;
    float d = 0.;
    Q=p,  d=D,  Q.x+=M_PI;
    d=min(d,D), Q.y+=M_PI;
    d=max(abs(min(d,D)+snoise3D(Q*2.)*.05),.01);
    return d*.5;
  }`